import React, { useState } from 'react';
import { platformModuleIconUrl } from '../../utils/platformAssets';
import { useIsDarkTheme } from '../../hooks/useDataTheme';

/**
 * 3D-иконка модуля из platform-assets (`/api/platform-assets/moduls/icons/...`).
 * См. markbase.ru/platform-assets/moduls/icons/README.md, STYLESYSTEM/rulesneiro/03_PLATFORM_ASSETS.md
 *
 * @param {string|null|undefined} assetKey — имя файла без суффикса (например `Shop`, `CRM`)
 * @param {React.ReactNode} fallback — Lucide/SVG при отсутствии ключа или ошибке загрузки
 * @param {boolean|null} forceDark — true: всегда `_dark.jpg`; false: всегда `_white.jpg`; null/undefined: из `data-theme`
 */
export default function PlatformModuleIcon({
  assetKey,
  fallback,
  forceDark,
  accentColor,
  className = '',
  imgClassName = 'mb-platform-module-icon__img',
  width = 28,
  height = 28,
  alt = '',
}) {
  const [failed, setFailed] = useState(false);
  const themeIsDark = useIsDarkTheme();
  const keyStr = typeof assetKey === 'string' ? assetKey.trim() : '';
  const use3d = Boolean(keyStr) && !failed;

  const isDark =
    forceDark === true ? true : forceDark === false ? false : themeIsDark;

  if (!use3d) {
    const tinted = Boolean(accentColor);
    return (
      <span
        className={`mb-platform-module-icon-fallback${tinted ? ' mb-platform-module-icon-fallback--tinted' : ''} ${className}`.trim()}
        style={tinted ? { '--mb-pmi-fallback-color': accentColor } : undefined}
      >
        {fallback}
      </span>
    );
  }

  return (
    <span className={`mb-platform-module-icon ${className}`}>
      <img
        src={platformModuleIconUrl(keyStr, isDark)}
        alt={alt}
        width={width}
        height={height}
        loading="lazy"
        decoding="async"
        className={imgClassName}
        onError={() => setFailed(true)}
      />
    </span>
  );
}
